<template><div><h1 id="regionengruppen" tabindex="-1"><a class="header-anchor" href="#regionengruppen"><span>Regionengruppen</span></a></h1>
<p>Regionengruppen — Regionengruppen definieren</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Eine Regionengruppe ist eine geografische Gruppierung, z.B. Sektioneneinteilung oder Verkaufsgebiete. Innerhalb dieser Gruppen können die einzelnen <RouteLink to="/referenz/refs/ft.refdata.tblregionen.html" title="Regionen">Regionen</RouteLink> über eine Kantons- und PLZ-Zuordnung definiert werden. Dies erfolgt in <RouteLink to="/referenz/refs/ft.refdata.regdef.html" title="Regionen definieren">Regionen definieren</RouteLink>.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Regionen</code></p>
<h2 id="datenfelder-anzeigemodus" tabindex="-1"><a class="header-anchor" href="#datenfelder-anzeigemodus"><span>Datenfelder (Anzeigemodus)</span></a></h2>
<dl>
<dt>Regionengruppe</dt>
<dd>Kurzbezeichnung der Regionengruppe</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung der Regionengruppe</dd>
</dl>
<h2 id="datenfelder-editmodus" tabindex="-1"><a class="header-anchor" href="#datenfelder-editmodus"><span>Datenfelder (Editmodus)</span></a></h2>
<dl>
<dt>Regionengruppe</dt>
<dd>Kurzbezeichnung der Regionengruppe</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung der Regionengruppe</dd>
<dt>übergeordnete Regionengruppe</dt>
<dd>Legt fest, welche Regionengruppe übergeordnet sein soll. Damit können beliebig viele Hierarchien eingerichtet werden. Diese Einstellung beschränkt die Auswahl der übergeordneten Region in den <a class="link" href="ft.refdata.tblregionen.html" title="Regionen">Regionen</a>.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.tblregionen.html" title="Regionen">Regionen</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.regdef.html" title="Regionen definieren">Regionen definieren</RouteLink></p>
</div></template>


